/**
 * Convert ISO 3166-1 alpha-2 country code to flag emoji
 * Uses Unicode regional indicator symbols
 * M6: Validates input contains only letters A-Z (case-insensitive)
 */
export function getCountryEmoji(countryCode: string): string {
  if (!countryCode || countryCode.length !== 2) {
    return '🌍'; // Default globe emoji for invalid codes
  }

  // M6: Validate letters-only (A-Z) - numeric or special chars produce invalid emojis
  if (!/^[A-Za-z]{2}$/.test(countryCode)) {
    return '🌍'; // Default globe emoji for non-letter codes
  }

  try {
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  } catch {
    return '🌍'; // Default globe emoji on error
  }
}
